"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const pick_1 = __importDefault(require("lodash/pick"));
const cookie_1 = require("cookie");
const WHITE_LIST_OPTIONS = [
    'domain',
    'expires',
    'path',
    'secure',
    'httpOnly',
    'maxAge',
    'sameSite'
];
const IS_CLIENT_SIDE = typeof document === 'object' && typeof document.cookie === 'string';
const decode = (str) => {
    if (!str) {
        return str;
    }
    return str.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
};
const setCookieToTheRequest = (request, name, cookieValue) => {
    var _a;
    if (request === null || request === void 0 ? void 0 : request.cookies) {
        const cookies = request.cookies;
        cookieValue === '' ? delete cookies[name] : cookies[name] = cookieValue;
        request.cookies = cookies;
    }
    if ((_a = request === null || request === void 0 ? void 0 : request.headers) === null || _a === void 0 ? void 0 : _a.cookie) {
        const cookies = (0, cookie_1.parse)(request.headers.cookie);
        cookieValue === '' ? delete cookies[name] : cookies[name] = cookieValue;
        request.headers.cookie = Object.entries(cookies).reduce((accum, item) => accum.concat(`${item[0]}=${item[1]};`), '');
    }
};
const get = (name, requestOrResponse) => {
    var _a, _b;
    // getting from browser
    if (IS_CLIENT_SIDE) {
        const cookie = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)(;|$)'));
        return (cookie && decode(cookie[1])) || null;
    }
    // getting from server
    if (requestOrResponse === null || requestOrResponse === void 0 ? void 0 : requestOrResponse.cookies) {
        const cookies = requestOrResponse.cookies;
        if (cookies && cookies[name]) {
            const cookie = cookies[name];
            return (cookie === null || cookie === void 0 ? void 0 : cookie.value) ? cookie.value : cookie;
        }
        // getting from nextjs middleware: https://nextjs.org/docs/messages/middleware-upgrade-guide#cookies-api-revamped
        if ((_a = cookies === null || cookies === void 0 ? void 0 : cookies.get) === null || _a === void 0 ? void 0 : _a.call(cookies, name)) {
            const cookie = cookies.get(name);
            return (cookie === null || cookie === void 0 ? void 0 : cookie.value) ? cookie.value : cookie;
        }
    }
    // getting from headers
    if ((_b = requestOrResponse === null || requestOrResponse === void 0 ? void 0 : requestOrResponse.headers) === null || _b === void 0 ? void 0 : _b.cookie) {
        const parsedCookies = (0, cookie_1.parse)(requestOrResponse.headers.cookie);
        const cookie = parsedCookies && parsedCookies[name];
        return cookie ? decode(cookie) : null;
    }
    return null;
};
const set = (name, value, options) => {
    var _a;
    try {
        const cookieValue = typeof value === 'string' ? value : JSON.stringify(value);
        const cookieOptions = (0, pick_1.default)({ path: '/', ...options }, WHITE_LIST_OPTIONS);
        // setting from browser
        if (IS_CLIENT_SIDE) {
            const cookie = (0, cookie_1.serialize)(name, cookieValue, cookieOptions);
            document.cookie = cookie;
            return true;
        }
        // setting from server
        const response = (options === null || options === void 0 ? void 0 : options.res) || (options === null || options === void 0 ? void 0 : options.response);
        const request = (options === null || options === void 0 ? void 0 : options.req) || (options === null || options === void 0 ? void 0 : options.request);
        if (typeof (response === null || response === void 0 ? void 0 : response.cookie) === 'function') {
            response.cookie(name, cookieValue, cookieOptions);
            setCookieToTheRequest(request, name, cookieValue);
            return true;
        }
        // setting from nextjs middlware: https://nextjs.org/docs/messages/middleware-upgrade-guide#cookies-api-revamped
        if (typeof ((_a = response === null || response === void 0 ? void 0 : response.cookies) === null || _a === void 0 ? void 0 : _a.set) === 'function') {
            response.cookies.set(name, cookieValue, cookieOptions);
            setCookieToTheRequest(request, name, cookieValue);
            return true;
        }
        // setting from the headers
        if ((response === null || response === void 0 ? void 0 : response.getHeader) && (response === null || response === void 0 ? void 0 : response.setHeader)) {
            let currentCookies = response.getHeader('Set-Cookie');
            if (!Array.isArray(currentCookies)) {
                currentCookies = !currentCookies ? [] : [String(currentCookies)];
            }
            const cookie = (0, cookie_1.serialize)(name, cookieValue, cookieOptions);
            response.setHeader('Set-Cookie', currentCookies.concat(cookie));
            setCookieToTheRequest(request, name, cookieValue);
            return true;
        }
        return false;
    }
    catch (error) {
        console.error('[Cookies.set] Failed to set cookie with error:', error);
        return false;
    }
};
const update = (name, value, options) => {
    return set(name, value, options);
};
const remove = (name, options) => {
    return set(name, '', { ...options, maxAge: -1 });
};
const Cookies = {
    get,
    set,
    update,
    remove
};
exports.default = Cookies;
//# sourceMappingURL=cookies.js.map